module.exports = __webpack_public_path__ + "static/media/logo-basa.e34dc23d.svg";